<template>
  <v-dialog v-model="show" width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text class="text-xs-center">
        <v-icon v-if="success === 'SUCCESS'" large color="teal darken-2"
          >check_circle</v-icon
        >
        <v-icon v-if="success && success !== 'SUCCESS'" large color="red"
          >error</v-icon
        >
        {{ message }}</v-card-text
      >
      <v-card-actions class="justify-center">
        <v-btn @click="confirm">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    title: '',
    message: '',
    show: false,
    success: null,
  }),
  methods: {
    popup(title, message, success) {
      this.show = true
      this.message = message
      this.title = title
      this.success = success
    },
    confirm() {
      this.show = false
    },
  },
}
</script>
